import { db } from "../firebase/config";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  query,
  orderBy
} from "firebase/firestore";

const proctorAvailabilityRef = collection(db, "proctorAvailability");

export const addProctorAvailability = async (proctorFirstName, proctorLastName, availability, proctorLocation) => {
    try {
        console.log(proctorFirstName);
        console.log(proctorLastName);
        console.log(availability);
        await addDoc(proctorAvailabilityRef, {
            proctorFirstName: proctorFirstName,
            proctorLastName : proctorLastName,
            availability: availability,
            location: proctorLocation,
        });
        console.log("Doc was added");
    } catch (error) {
        console.error("Doc could not be added", error);
    }
};


export const readProctorAvailability = async () => {
    try {
        // Create the query to get documents ordered by 'proctorLastName'
        const q = query(proctorAvailabilityRef, orderBy("proctorLastName"));

        // Execute the query and fetch the documents
        const data = await getDocs(q);

        // Map the documents into an array of proctor availability
        const availability = data.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id, // Add document id to each result
        }));

        return availability;  // Return the sorted proctor availability

    } catch (error) {
        console.error("Error reading proctor availability: ", error);
        return [];  // Return empty array on error
    }
};


// Update proctor availability based on proctor's full name
export const updateProctorAvailability = async (proctorFullName, updatedAvailability) => {
    try {
        // Split full name into first name and last name
        const [firstName, lastName] = proctorFullName.split(" ");

        // Fetch all documents in the 'proctorAvailability' collection
        const snapshot = await getDocs(proctorAvailabilityRef);

        // Filter to find the proctor's document based on the name
        const proctorDoc = snapshot.docs.find(docSnapshot => {
            const data = docSnapshot.data();
            return data.proctorFirstName === firstName && data.proctorLastName === lastName;
        });

        if (proctorDoc) {
            // Get the document reference for the matching proctor
            const proctorDocRef = doc(db, "proctorAvailability", proctorDoc.id);

            // Update the document with new availability data
            await updateDoc(proctorDocRef, {
                availability: updatedAvailability,
            });

            console.log(`Proctor ${proctorFullName}'s availability updated successfully.`);
        } else {
            console.log("Proctor not found.");
        }
    } catch (error) {
        console.error("Error updating proctor availability: ", error);
    }
};

export const deleteProctor = async (proctorFullName) => {
    try {
        // Split the full name into first and last name
        const [firstName, lastName] = proctorFullName.split(" ");

        // Fetch all documents in the 'proctorAvailability' collection
        const snapshot = await getDocs(proctorAvailabilityRef);

        // Find the proctor document based on the first and last name
        const proctorDoc = snapshot.docs.find(docSnapshot => {
            const data = docSnapshot.data();
            return data.proctorFirstName === firstName && data.proctorLastName === lastName;
        });

        if (proctorDoc) {
            // Get the document reference for the matching proctor
            const proctorDocRef = doc(db, "proctorAvailability", proctorDoc.id);

            // Delete the proctor document
            await deleteDoc(proctorDocRef);

            console.log(`Proctor ${proctorFullName} deleted successfully.`);
        } else {
            console.log("Proctor not found.");
        }
    } catch (error) {
        console.error("Error deleting proctor: ", error);
    }
};









